import QAResponseQuestionEntity from "../../domain/entities/qa_response_question.entity";

const fromJSON = (json: any):QAResponseQuestionEntity => {
    return {
        id: json.id?.toString() ?? '',
        short: json.answer,
        justification: json.justification,
        points: json.score,
        questionId: json.question_id,
        answer: json.answer
    }
}

const toJSON = (entity: QAResponseQuestionEntity): any => {
    const shortInput = entity.short.trim().toLowerCase();

    let short: string;
    if (shortInput === 'yes') short = 'Yes';
    else if (shortInput === 'no') short = 'No';
    else if (shortInput === 'not applicable') short = 'Not Applicable';
    else throw new Error(`Valor inválido para 'short': '${entity.short}'`);

    return {
        custom_id: parseInt(entity.id ?? "0"),
        custom_response: entity.justification,
        custom_score: entity.points,
        question_id: entity.questionId,
        custom_answer: short,
    };
};


const QAResponseQuestionDto = {
    fromJSON,
    toJSON,
}

export default QAResponseQuestionDto;